<div class="modal fade" bsModal #diffModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg diff-dialog">
    <div class="panel padding-2">
      <div class="panel-heading">
        <span class="panel-title">{{'Changes' | translate}}</span>
      </div>
      <div class="row panel-body padding-sm-hr">
        <div class="col-sm-12">
          <div *ngIf="!hasOriginal" class="alert alert-info">
            The original values for this request were not recorded, so only the submitted (new) values are shown below.
          </div>
          <div *ngIf="hasOriginal && rows.length===0" class="alert alert-info">
            No fields were changed in this request.
          </div>
          <table class="table diff-table" *ngIf="rows.length>0">
            <thead>
              <tr>
                <th class="diff-field-col">{{'Field' | translate}}</th>
                <th>{{'Old Value' | translate}}</th>
                <th></th>
                <th>{{'New Value' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rows">
                <td class="diff-field-col">{{ row.label }}</td>
                <td class="diff-old-value">{{ row.oldValue }}</td>
                <td class="diff-arrow"><i class="fa fa-long-arrow-right" aria-hidden="true"></i></td>
                <td class="diff-new-value">{{ row.newValue }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="panel-footer margin-left-20 margin-top-20 text-right">
        <button type="button" (click)="hide()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
      </div>
    </div>
  </div>
</div>
